import React, { Component, PropTypes } from 'react';
import Translator from 'bazinga-translator';

export default class EditPopup extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        desc: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.getData = this.getData.bind(this);
    }

    handleSave(e) {
        e.preventDefault();
        console.log(this.getData());
        this.props.onSave(this.getData())
    }

    handleCancel(e) {
        e.preventDefault();
        this.props.onCancel();
    }

    getData() {
        return {
            title: this.refs.title.value,
            desc: this.refs.desc.value
        }
    }

    render() {
        return (
        <div className="pop-up__box">
            <form id="edit-form">
                <div className="pop-up__content">
                    <h2>{Translator.trans('drafts.popup.edit_header', [], 'app')}</h2>
                    <label for="username">{Translator.trans('drafts.popup.title', [], 'app')}</label>
                    <div className="input"><input type="text" id="title" autoFocus={true} ref="title"
                                                  defaultValue={this.props.title}/></div>
                    <label for="description">{Translator.trans('drafts.popup.desc', [], 'app')}</label>
                    <div className="input">
                        <textarea id="description" ref="desc" defaultValue={this.props.desc}/>
                    </div>
                </div>
                <div className="pop-up__buttons">
                    <button className="btn-popup" onClick={::this.handleCancel}>{Translator.trans('cancel', [], 'app')}</button>
                    <button className="btn-popup -primary" type="submit" onClick={::this.handleSave}>{Translator.trans('drafts.popup.edit_save', [], 'app')}
                    </button>
                </div>
            </form>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/_app/drafts/components/EditPopup.jsx